export const GET_SHARES_COLUMNS_REQUEST = 'GET_SHARES_COLUMNS_REQUEST';
export const GET_SHARES_COLUMNS_SUCCESS = 'GET_SHARES_COLUMNS_SUCCESS';
export const GET_SHARES_COLUMNS_FAILURE = 'GET_SHARES_COLUMNS_FAILURE';

export const GET_SHARES_REQUEST = 'GET_SHARES_REQUEST';
export const GET_INITIAL_SHARES_SUCCESS = 'GET_INITIAL_SHARES_SUCCESS';
export const GET_SHARES_SUCCESS = 'GET_SHARES_SUCCESS';
export const GET_SHARES_FAILURE = 'GET_SHARES_FAILURE';

export const SAVE_SHARES_SEARCH_PARAMETERS = 'SAVE_SHARES_SEARCH_PARAMETERS';

export const SELECT_SHARES_SUCCESS = 'SELECT_SHARES_SUCCESS';
export const SELECT_ALL_SHARES_SUCCESS = 'SELECT_ALL_SHARES_SUCCESS';
